import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c8cd44f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex",
    "padding-left": "20px",
    "padding-top": "20px",
    "background-color": "white"
  }
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "background-color": "#e8e8e8"
  }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  style: {}
};
const _hoisted_5 = {
  style: {
    "padding-left": "3%",
    "font-size": "14px"
  }
};
const _hoisted_6 = {
  class: "app-footer",
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "padding": "20px",
    "background-color": "white"
  }
};
const _hoisted_7 = {
  class: "container",
  style: {
    "width": "100%",
    "max-width": "1200px",
    "text-align": "center"
  }
};
const _hoisted_8 = {
  style: {
    "margin": "0",
    "padding": "0",
    "line-height": "1.6"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#terms",
  style: {
    "margin": "0 8px",
    "color": "#666",
    "text-decoration": "none"
  }
}, "服务条款", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#privacy",
  style: {
    "margin": "0 8px",
    "color": "#666",
    "text-decoration": "none"
  }
}, "隐私政策", -1));
import { ref, reactive, onMounted } from 'vue';
import { ActivitiesLabelController, ActivitiesController, ActivitiesPosterController } from '@/api/generated';
import { useDownload } from "@/common/hooks/useDownload";
import { useUpload } from "@/common/hooks/useUpload";
import { useCommon } from "@/common/hooks/useCommon";

import { computed } from 'vue';
const __default__ = {
  name: 'cloudActivities'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      formatDateByStatsType
    } = useCommon();
    const drawer = ref(false);
    const windowWidth = ref(window.innerWidth);
    // 判断是否为手机模式（例如：小于 1024px 视为小屏）
    const isMobile = computed(() => {
      return windowWidth.value < 1024; // 可根据设计断点调整
    });
    // 控制表单是否可见：小屏时隐藏，大屏时显示
    const isFormVisible = computed(() => {
      return !isMobile.value;
    });
    // 图片缩放相关状态 - 记录当前放大的图片索引，-1表示没有放大的图片
    const zoomedImageIndex = ref(-1);
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      fileListToJson,
      parseUploadDataSimple,
      getPictureList
    } = useUpload();
    const activeIndex = ref(0);
    const handleSelect = key => {
      console.log("key===============>", key);
      // 重置图片缩放状态
      zoomedImageIndex.value = -1;
      const params = {
        // activitiesDtoFilter: {
        //   activitiesLabelId: formActivitiesTableWidgetData.value[Number(key)].activitiesLabelId,
        // activitiesLabelId: formActivitiesLabelTableWidgetData.value[Number(key)].activitiesLabelId,
        // }
      };
      postersUrlsWidgetFileList.value = [];
      introduceUrlsWidgetFileList.value = [];
      signUpHeaderImgWidgetFileList.value = [];
      signUpBgImgWidgetFileList.value = [];
      // loadFormActivitiesTableWidgetData(params).then(res => {
      //   if (res.dataList.length > 0) {
      //     const activityParams = {
      //       activityId: res.dataList[0].activityId
      //     }
      //     loadActivitiesPosterData(activityParams)
      //   }
      // });
      // console.log("formActivitiesTableWidgetData===============>",formActivitiesTableWidgetData.value[Number(key)].activityId)
      const activityParams = {
        // activityId: formActivitiesTableWidgetData.value[Number(key)].activityId
        activityId: key.toString()
      };
      loadActivitiesPosterData(activityParams);
    };
    const drawerHandleSelect = key => {
      // 重置图片缩放状态
      zoomedImageIndex.value = -1;
      const params = {
        // activitiesDtoFilter: {
        //   activitiesLabelId: formActivitiesTableWidgetData.value[Number(key)].activitiesLabelId,
        // activitiesLabelId: formActivitiesLabelTableWidgetData.value[Number(key)].activitiesLabelId,
        // }
      };
      postersUrlsWidgetFileList.value = [];
      introduceUrlsWidgetFileList.value = [];
      signUpHeaderImgWidgetFileList.value = [];
      signUpBgImgWidgetFileList.value = [];
      // loadFormActivitiesTableWidgetData(params).then(res => {
      //   if (res.dataList.length > 0) {
      //     const activityParams = {
      //       activityId: res.dataList[0].activityId
      //     }
      //     loadActivitiesPosterData(activityParams)
      //   }
      // });
      // console.log("formActivitiesTableWidgetData===============>",formActivitiesTableWidgetData.value[Number(key)].activityId)
      const activityParams = {
        activityId: formActivitiesTableWidgetData.value[Number(key)].activityId
      };
      loadActivitiesPosterData(activityParams);
      drawer.value = false;
    };
    const currentYear = new Date().getFullYear();
    /**
     * 加载活动标签数据
     */
    const loadFormActivitiesLabelTableWidgetData = params => {
      return new Promise((resolve, reject) => {
        ActivitiesLabelController.list(params).then(res => {
          formActivitiesLabelTableWidgetData.value = res.data.dataList;
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    const formActivitiesLabelTableWidgetData = ref([]);
    const formActivitiesTableWidgetData = ref([]);
    /**
     * 加载活动数据
     */
    const loadFormActivitiesTableWidgetData = params => {
      const queryParams = params || {};
      return new Promise((resolve, reject) => {
        ActivitiesController.list(queryParams).then(res => {
          formActivitiesTableWidgetData.value = res.data.dataList;
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    const postersUrlsWidgetFileList = ref([]);
    const introduceUrlsWidgetFileList = ref([]);
    const signUpHeaderImgWidgetFileList = ref([]);
    const signUpBgImgWidgetFileList = ref([]);
    const ActivitiesPoster = reactive({
      activityPosterId: undefined,
      activityId: undefined,
      introduceUrls: undefined,
      postersUrls: undefined,
      signUpHeaderImg: undefined,
      signUpBgImg: undefined,
      createUserId: undefined,
      createTime: undefined,
      updateUserId: undefined,
      updateTime: undefined,
      platformType: undefined,
      deletedFlag: undefined,
      deptId: undefined
    });
    const getActivitiesImgData = activities => {
      const activityImgParams = {
        activityId: activities.activityId,
        fieldName: 'activityImg',
        asImage: true
      };
      const activityImgData = parseUploadDataSimple(activities.activityImg, activityImgParams);
      console.log("activities===============>", activityImgData[0].url);
      return activityImgData[0].url;
    };
    /**
     * 加载活动海报数据
     */
    const loadActivitiesPosterData = params => {
      return new Promise(resolve => {
        ActivitiesPosterController.view(params).then(res => {
          Object.assign(ActivitiesPoster, res.data);
          const postersUrlsDownloadParams = {
            activityPosterId: ActivitiesPoster.activityPosterId,
            fieldName: 'postersUrls',
            asImage: true
          };
          postersUrlsWidgetFileList.value = parseUploadDataSimple(ActivitiesPoster.postersUrls, postersUrlsDownloadParams);
          const introduceUrlsDownloadParams = {
            activityPosterId: ActivitiesPoster.activityPosterId,
            fieldName: 'introduceUrls',
            asImage: true
          };
          introduceUrlsWidgetFileList.value = parseUploadDataSimple(ActivitiesPoster.introduceUrls, introduceUrlsDownloadParams);
          const signUpHeaderImgDownloadParams = {
            activityPosterId: ActivitiesPoster.activityPosterId,
            fieldName: 'signUpHeaderImg',
            asImage: true
          };
          signUpHeaderImgWidgetFileList.value = parseUploadDataSimple(ActivitiesPoster.signUpHeaderImg, signUpHeaderImgDownloadParams);
          const signUpBgImgDownloadParams = {
            activityPosterId: ActivitiesPoster.activityPosterId,
            fieldName: 'signUpBgImg',
            asImage: true
          };
          signUpBgImgWidgetFileList.value = parseUploadDataSimple(ActivitiesPoster.signUpBgImg, signUpBgImgDownloadParams);
          resolve();
        });
      });
    };
    /**
     * 切换图片缩放状态
     */
    const toggleImageZoom = index => {
      // 如果点击的是已放大的图片，则恢复原状；否则放大当前图片并重置其他图片
      if (zoomedImageIndex.value === index) {
        zoomedImageIndex.value = -1;
      } else {
        zoomedImageIndex.value = index;
      }
    };
    const formInit = () => {
      const params = {
        activitiesLabelDtoFilter: {
          labelName: "202508光明世界创享会"
        }
      };
      loadFormActivitiesLabelTableWidgetData(params).then(() => {
        if (formActivitiesLabelTableWidgetData.value.length > 0) {
          const activityParams = {
            activitiesDtoFilter: {
              activitiesLabelId: formActivitiesLabelTableWidgetData.value[0].activitiesLabelId
            }
          };
          loadFormActivitiesTableWidgetData(activityParams).then(res => {
            if (res.dataList.length > 0) {
              loadActivitiesPosterData({
                activityId: res.dataList[0].activityId
              });
            }
          });
        }
        activeIndex.value = 0;
      });
    };
    onMounted(() => {
      formInit();
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_menu, {
        style: {
          "padding": "1% 20%",
          "align-items": "center",
          "justify-content": "center",
          "width": "100%",
          "height": "80px"
        },
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        "background-color": "#545c64",
        "text-color": "#ffff",
        "active-text-color": "#ffd04b"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formActivitiesTableWidgetData.value, (activities, index) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_el_menu_item, {
            onClick: $event => handleSelect(`${activities.activityId}`),
            index: index
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(activities.activityName.replace('202508光明世界创享会', '')), 1)]),
            _: 2
          }, 1032, ["onClick", "index"]), [[_vShow, _unref(isFormVisible) && index != 2]]), _withDirectives(_createVNode(_component_el_sub_menu, {
            index: index
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(activities.activityName.replace('202508光明世界创享会', '')), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formActivitiesTableWidgetData.value, (subActivities, subIndex) => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                onClick: $event => handleSelect(`${subActivities.activityId}`),
                index: `${index}-${subIndex}`
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(subActivities.activityName.replace('202508光明世界创享会', '')), 1)]),
                _: 2
              }, 1032, ["onClick", "index"]);
            }), 256))]),
            _: 2
          }, 1032, ["index"]), [[_vShow, _unref(isFormVisible) && index == 2]])], 64);
        }), 256)), _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          style: {
            "margin-right": "-120%"
          },
          onClick: _cache[0] || (_cache[0] = $event => drawer.value = true)
        }, {
          default: _withCtx(() => [_createTextVNode(" ☰ ")]),
          _: 1
        }, 512), [[_vShow, !_unref(isFormVisible)]])]),
        _: 1
      }, 8, ["default-active"]), _createVNode(_component_el_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => drawer.value = $event),
        direction: "ltr",
        size: '100%'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "default-active": activeIndex.value,
          class: "drawer-menu",
          mode: "vertical"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formActivitiesTableWidgetData.value, (activities, index) => {
            return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_menu_item, {
              class: "drawer-menu-item",
              onClick: $event => handleSelect(`${activities.activityId}`),
              index: index
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(activities.activityName.replace('202508光明世界创享会', '')), 1)]),
              _: 2
            }, 1032, ["onClick", "index"]), _withDirectives(_createVNode(_component_el_sub_menu, {
              class: "drawer-menu-item",
              index: index
            }, {
              title: _withCtx(() => [_createTextVNode(_toDisplayString(activities.activityName.replace('202508光明世界创享会', '')), 1)]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formActivitiesTableWidgetData.value, (subActivities, subIndex) => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  onClick: $event => handleSelect(`${subActivities.activityId}`),
                  index: `${index}-${subIndex}`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(subActivities.activityName.replace('202508光明世界创享会', '')), 1)]),
                  _: 2
                }, 1032, ["onClick", "index"]);
              }), 256))]),
              _: 2
            }, 1032, ["index"]), [[_vShow, _unref(isFormVisible) && index == 2]])], 64);
          }), 256))]),
          _: 1
        }, 8, ["default-active"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formActivitiesTableWidgetData.value, (activities, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "display": "flex",
            "flex-direction": "column",
            "gap": "10px",
            "border": "3px solid whitesmoke",
            "border-radius": "8px",
            "width": "60%"
          }
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          style: {
            "width": "40%",
            "height": "auto",
            "object-fit": "cover",
            "border-radius": "20px",
            "padding": "3%"
          },
          src: getActivitiesImgData(activities),
          alt: "活动图片"
        }, null, 8, _hoisted_3), _createElementVNode("p", _hoisted_4, _toDisplayString(activities.activityName.replace('202508光明世界创享会', '')), 1)]), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_5, _toDisplayString(_unref(formatDateByStatsType)(activities.createTime, 'day')), 1)])]);
      }), 128))]), _createElementVNode("footer", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, [_createTextVNode(" © " + _toDisplayString(_unref(currentYear)) + " 我的公司. 版权所有. ", 1), _hoisted_9, _hoisted_10])])])], 64);
    };
  }
});